import './c-toggle-stateless.scss';
import template from './toggle-stateless.vhtml';

export default {
	template,
	props: {
		options: {
			type: Array,
			default: () => ([]),
		},
		selected: {
			type: [ String, Number ],
		},
	},
	methods: {
		toggle( option ) {
			// Emit empty string to deselect if already selected
			if ( this.selected === option.value ) {
				this.$emit( 'select', '' );
			} else {
				this.$emit( 'select', option.value );
			}
		},     
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/toggle-stateless/toggle-stateless.js